import PubSub from '../PubSub'

interface WishlistState {
  totalItemsCount: number
}

class WishlistStateManager extends PubSub {
  private state: WishlistState
  constructor() {
    super()
    this.state = { totalItemsCount: 0 }
  }
  setWishlistTotalItemsCount = (totalItemsCount: number) => {
    this.state.totalItemsCount = totalItemsCount
    this.publish()
  }
  getWishlistTotalItemsCount = () => {
    return this.state.totalItemsCount
  }
}

const wishListStateManager: WishlistStateManager = WishlistStateManager.getInstance('wishListStateManager')

export default wishListStateManager
